// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hj-6";
export var emphasizeQuantity = "_hj-3";
export var flatBottomCorners = "_hj-5";
export var productImage = "_hj-0";
export var quantityContainer = "_hj-2";
export var tooltip = "_hj-1";
export var wrapAndEllipsesOverflow = "_hj-4";